(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroes = document.querySelectorAll('[data-tm-hero-swing]');
    if (heroes.length === 0) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    let alreadySwung = false;
    try {
      alreadySwung = sessionStorage.getItem('tm-hero-swung') === '1';
      sessionStorage.setItem('tm-hero-swung', '1');
    } catch (error) {
      // Storage can be blocked; swinging on every visit is an acceptable fallback.
    }
    if (alreadySwung) return;

    for (const hero of heroes) {
      hero.classList.add('tm-hero--swing');
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tm-recently-viewed"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tm-recently-viewed')) {
    class TmRecentlyViewed extends HTMLElement {
      static storageKey = 'tm-recently-viewed';

      connectedCallback() {
        const current = this.dataset.current;
        const limit = Number(this.dataset.limit) || 8;
        let handles = this.#read();

        if (current) {
          handles = [current, ...handles.filter((handle) => handle !== current)].slice(0, 12);
          this.#write(handles);
        }

        const toShow = handles.filter((handle) => handle !== current).slice(0, limit);
        if (toShow.length === 0) return;
        this.#render(toShow);
      }

      #read() {
        try {
          const value = JSON.parse(localStorage.getItem(TmRecentlyViewed.storageKey) || '[]');
          return Array.isArray(value) ? value.filter((handle) => typeof handle === 'string') : [];
        } catch (error) {
          return [];
        }
      }

      #write(handles) {
        try {
          localStorage.setItem(TmRecentlyViewed.storageKey, JSON.stringify(handles));
        } catch (error) {
          // Storage can be unavailable (private mode); the section simply stays hidden.
        }
      }

      #rands(cents) {
        const rands = Math.floor(cents / 100);
        const remainder = cents % 100;
        const whole = rands.toLocaleString('en-US');
        return { whole, cents: remainder > 0 ? String(remainder).padStart(2, '0') : '' };
      }

      #ticket(price, compareAt) {
        const onSale = compareAt && compareAt > price;
        const { whole, cents } = this.#rands(price);
        const ticket = document.createElement('span');
        ticket.className = 'tm-price tm-recent__price';
        ticket.setAttribute('translate', 'no');
        const label = document.createElement('span');
        label.className = `tm-ticket tm-ticket--sm${onSale ? ' tm-ticket--sale' : ''}`;
        label.setAttribute('aria-hidden', 'true');
        label.innerHTML = `<span class="tm-ticket__currency">R</span>${whole}${cents ? `<span class="tm-ticket__cents">${cents}</span>` : ''}`;
        const readable = document.createElement('span');
        readable.className = 'visually-hidden';
        readable.textContent = `R ${(price / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
        ticket.append(label, readable);
        return ticket;
      }

      async #render(handles) {
        const list = this.querySelector('.tm-recent__list');
        const root = window.Shopify?.routes?.root || '/';
        const results = await Promise.all(
          handles.map(async (handle) => {
            try {
              const response = await fetch(`${root}products/${encodeURIComponent(handle)}.js`);
              if (!response.ok) return null;
              return await response.json();
            } catch (error) {
              return null;
            }
          })
        );

        const products = results.filter(Boolean);
        if (products.length === 0) {
          this.#write(handles.filter((handle) => results.some((product) => product && product.handle === handle)));
          return;
        }

        for (const product of products) {
          const item = document.createElement('li');
          item.className = 'tm-recent__item';
          const link = document.createElement('a');
          link.className = 'tm-recent__tile';
          link.href = product.url;

          const media = document.createElement('span');
          media.className = 'tm-recent__media';
          const imageSource = product.featured_image;
          if (imageSource) {
            const image = document.createElement('img');
            const url = new URL(imageSource, window.location.origin);
            url.searchParams.set('width', '320');
            image.src = url.toString();
            image.width = 320;
            image.height = 320;
            image.loading = 'lazy';
            image.alt = product.media?.[0]?.alt || product.title;
            image.className = 'tm-recent__image';
            media.append(image);
          }

          const name = document.createElement('span');
          name.className = 'tm-recent__name';
          name.textContent = product.title.split(' — ')[0];

          const variant = product.variants.find((entry) => entry.available) || product.variants[0];
          link.append(media, name, this.#ticket(variant.price, variant.compare_at_price));
          item.append(link);
          list.append(item);
        }
        this.hidden = false;
      }
    }
    customElements.define('tm-recently-viewed', TmRecentlyViewed);
  }

  } catch(e) { console.error(e); }
})();
})();
